module.exports = __webpack_public_path__ + "media/img/private-venue/pin-fa3c8a3527e75a93f6729a9344c5813b.svg";